import {
  colors,
  Flex,
  Heading,
  Icon,
  IconType,
} from '@weareberyl/design-system'
import { ReactNode } from 'react'

interface Props {
  iconType: IconType
  children: ReactNode
  withLink?: boolean
}

const IconHeading = ({ iconType, children, withLink = false }: Props) => {
  const color = withLink ? colors.textLink : undefined
  return (
    <Heading color={color}>
      <Flex
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 3,
          flexWrap: 'none',
        }}
      >
        <Icon type={iconType} color={color} />
        <Heading variant="h1" color={color}>
          {children}
        </Heading>
      </Flex>
    </Heading>
  )
}

export default IconHeading
